import {
	KuposSelectBox,
	LoginModal,
} from '../../../common';
import React, { useRef, useState } from 'react';

import getIcons from '../../functions/getIcons/getIcons';

const CuponeraInput = props => {
	const { t, history, home, actions, operator, common } = props.data;
	const errorInitialState = {
		source: '',
		destination: '',
		date: '',
	};
	const [error, setError] = useState(errorInitialState);
	const destinationRef = useRef({});

	const onSourceChange = value => {
		setError({ ...error, source: null });
		actions.pbSetSourceCity(value);
		getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity);

		if (home.pbDestinationCity && value.value === home.pbDestinationCity.value) {
			onDestinationChange(null);
		}

		destinationRef.current.onMenuOpen();
		destinationRef.current.select.focus();
	};

	const onDestinationChange = value => {
		setError({ ...error, destination: null });
		actions.pbSetDestinationCity(value);
	};

	const getOriginSelectedFilteredDestinations = (rawArray, itemToRemove) => {
		if (rawArray && itemToRemove) {
			return rawArray
				.map(function (obj) {
					if (obj.label == itemToRemove.label) {
					} else {
						return obj;
					}
				})
				.filter(function (obj) {
					return typeof obj !== 'undefined';
				});
		} else if (!itemToRemove) {
			// return rawArray;
		}
	};
	const onSubmit = e => {
		e.preventDefault();
		// if (!common.loginData) {
		// 	actions.openCloseLoginModal(true);
		// } else



		if (!home.pbSourceCity) {
			setError({ ...error, source: 'VALIDATIONS.VALID_ORIGIN_CITY' });
			return;
		} else if (!home.pbDestinationCity) {
			setError({ ...error, destination: 'VALIDATIONS.VALID_DESTINATION_CITY' });
			return;
		} else {
			sessionStorage.setItem('cuponeraSourceCity', JSON.stringify(home.pbSourceCity));
			sessionStorage.setItem('cuponeraDestinationCity', JSON.stringify(home.pbDestinationCity));

			history.push('/cuponera/seats');
		}
	};

	return (
		<React.Fragment>
			<form onSubmit={onSubmit}>
				<div className="home-selection-input-boxes">
					<div className="home-selection-input-box font10">
						{/* <span className="label font11">{t('HOME.ORIGIN')}</span> */}
						<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.ORIGIN')}</span>

						<KuposSelectBox
							reactSelect
							selectType="origin"
							options={home.uniqueCities || []}
							selectedOption={home.pbSourceCity}
							onChange={onSourceChange}
							icon={getIcons('Origin', operator)}
							hideArrow={true}
							error={error.source ? true : false}
							errorMessage={t(error.source)}
							// placeholder={t('HOME.ORIGIN')}
							placeholder={operator && operator.operator_name === "pullmandelsur" ? "Ciudad de Origen" : t('HOME.ORIGIN')}
							height={40}
							t={t}
						/>
					</div>

					<div className="home-selection-input-box font10">
						{/* <span className="label font11">{t('HOME.DESTINATION')}</span> */}
						<span className={operator && operator.operator_name === "pullmandelsur" ? "label font11 bold-text" : "label font11"}>{t('HOME.DESTINATION')}</span>

						<KuposSelectBox
							reactSelect
							selectType="destination"
							selectRef={destinationRef}
							options={
								home.pbSourceCity
									? getOriginSelectedFilteredDestinations(home.uniqueCities, home.pbSourceCity)
									: []
							}
							selectedOption={home.pbDestinationCity}
							onChange={onDestinationChange}
							icon={getIcons('Destination', operator)}
							hideArrow={true}
							error={error.destination ? true : false}
							errorMessage={t(error.destination)}
							// placeholder={t('HOME.DESTINATION')}
							placeholder={operator && operator.operator_name === "pullmandelsur" ? "Ciudad de Destino" : t('HOME.DESTINATION')}
							height={40}
							t={t}
						/>
					</div>

					<div className="home-selection-input-box font12 datebox">
						<button
							style={{
								background:
									operator && operator.color_codes && operator.color_codes.button_color
										? operator.color_codes.button_color
										: '',
							}}
							className="kupos-button home-selection-input-button less-bold-text hello "
							type="submit"
						>
							<img src={getIcons('Search', operator)} alt="" style={{ height: 30 }} />
							<span>{t('HOME.SEARCH')}</span>
						</button>
					</div>
				</div>
			</form>
			{home.metaData ? (
				<LoginModal
					showModal={common.showLoginModal}
					onHide={() => actions.openCloseLoginModal(false)}
					common={common}
					//   pbPaymentDetails={this.props.pbPaymentDetails}
					metaData={home.metaData}
					actions={actions}
					t={t}
					onLoginSuccess={() => actions.openCloseLoginModal(false)}
					onSignupSuccess={() => actions.openCloseLoginModal(false)}
					history={history}
					operator={home.operator}
				/>
			) : null}
		</React.Fragment>
	);
};


export default CuponeraInput


// WEBPACK FOOTER //
// ./src/features/themes/ThemeTen/components/copunera-inputs.js